import React from "react";
import GoogleLogo from "../assets/images/google-logo.png";
import { useStyles } from "./style";
import { useIntl } from "react-intl";
import { isServeFirstBrandingHidden } from "../helpers/serveFirstBranding";
import { SERVE_FIRST_LOGO } from "../constants/branding";

function MobileRatingThankYou() {
  const intl = useIntl();
  const backgroundClasses = useStyles();
  const showGoogle = localStorage.getItem("showGoogle") === "true";
  const googleLink = localStorage.getItem("googleLink") || "";
  const hideServeFirst = isServeFirstBrandingHidden();

  return (
    <div style={{ minHeight: "100%" }}>
      <section className={`login-wrapper ${backgroundClasses.backgroundImg}`}>
        <div className={backgroundClasses.container}>
          <img
            src="/images/webRating/check.png"
            style={{ width: "20vw" }}
            alt="checkicon"
          />
          <h2
            className={backgroundClasses.thankyouText}
            style={{ marginTop: "1rem" }}
          >
            {intl.formatMessage({
              id: "thank-you-for-your-time-and-your-answers",
            })}
          </h2>

          {showGoogle ? (
            <>
              <h2
                className={backgroundClasses.thankyouText}
                style={{ marginTop: "4rem" }}
              >
                {intl.formatMessage({
                  id: "would-also-like-to-rate-us-on-google",
                })}
              </h2>

              <div className={backgroundClasses.googleReviewContainer}>
                <a
                  href={googleLink}
                  target="_blank"
                  rel="noreferrer"
                  className={backgroundClasses.googleReviewButton}
                >
                  <img
                    src={GoogleLogo}
                    alt="google-logo"
                    width="30px"
                    style={{ marginRight: "5px" }}
                  />
                  {intl.formatMessage({ id: "rate-us-now" })}
                </a>
              </div>
            </>
          ) : null}
        </div>
        {!hideServeFirst ? (
          <div
            className="logo d-flex align-items-center justify-content-center"
            style={{ position: "absolute", bottom: 9 }}
          >
            <span
              style={{
                marginRight: "15px",
                fontSize: "14px",
                color: "#FFF",
                fontWeight: "bold",
              }}
            >
              {intl.formatMessage({ id: "powered-by" })}
            </span>
            <img
              src={SERVE_FIRST_LOGO}
              alt="powerby"
              style={{ height: "50px" }}
            />
          </div>
        ) : null}
      </section>
    </div>
  );
}

export default MobileRatingThankYou;
